// React
import { useEffect, useState } from 'react'

// Mantine
import { Paper, ActionIcon, Button, Loader, Badge } from '@mantine/core'

// Custom

// UI
import ShipmentsTable from '@/components/shipments/ShipmentsTable'
import Breadcrumbs from '@/components/ui/Breadcrumbs'

export default function IndexShipments() {
    const rightSection = <Button variant="default">Créer un bordereau</Button>

    const layoutProps = {
        breadcrumbs: [
            {
                label: "Bordereaux d'expédition",
            },
        ],
        rightSection,
    }

    return (
        <div>
            <Breadcrumbs {...layoutProps} />
            <ShipmentsTable />
        </div>
    )
}
